import { BoxProps, FlexProps, IconButtonProps } from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Children } from "react";
import { SwiperProps, SwiperSlideProps } from "swiper/react";

type Props = FlexProps & {
  swiper_props?: BoxProps & SwiperProps;
  slide_props?: SwiperSlideProps;
  button_props?: IconButtonProps;
  showNav?: boolean;
};

export const Marquee = ({ children }: Props) => {
  return (
    <Splide
      options={{
        type: "loop",
        autoWidth: true,
        gap: "60px",
        padding: "10px",
        drag: "free",
        arrows: false,
        pagination: false,
        autoScroll: {
          pauseOnHover: true,
          pauseOnFocus: false,
          rewind: false,
          speed: 1,
        },
      }}
      extensions={{ AutoScroll }}
    >
      {Children.map(children, (child) => (
        <SplideSlide>{child}</SplideSlide>
      ))}
    </Splide>
  );
};
